export const SET_USER_INFO = 'SET_USER_INFO'

export const GET_USER_INFO = 'GET_USER_INFO';

export const SET_SHOW_CHAT_BUTTON = 'SET_SHOW_CHAT_BUTTON';

export const SET_SHOW_CHAT_BOX = 'SET_SHOW_CHAT_BOX';

